
const Visibility = (props) => {
    return (
        <svg data-name="View Icon" xmlns="http://www.w3.org/2000/svg" width="19" height="10" viewBox="0 0 19 10">
            <g data-name="Group 894">
                <g data-name="Path 433" strokeLinecap="round" strokeLinejoin="round" fill="#fff">
                    <path d="M9.5 9.5C5.305 9.5 1.71 6.081.678 5a18.093 18.093 0 0 1 2.418-2.11C4.6 1.8 6.932.5 9.5.5c4.195 0 7.79 3.419 8.822 4.5a18.092 18.092 0 0 1-2.418 2.11C14.4 8.2 12.068 9.5 9.5 9.5z" stroke="none" />
                    <path d="M9.5 1C5.876 1 2.68 3.724 1.38 5.001 2.677 6.28 5.863 9 9.5 9c3.624 0 6.82-2.724 8.12-4.001C16.323 3.72 13.137 1 9.5 1m0-1C14.747 0 19 5 19 5s-4.253 5-9.5 5S0 5 0 5s4.253-5 9.5-5z" fill="#14a4c2" stroke="none"/>
                </g>
                <ellipse data-name="Ellipse 49" cx="2.759" cy="2.6" rx="2.759" ry="2.6" transform="translate(6.741 2.028)" stroke="#fcb364" strokeWidth="1.5px" fill="#fff" />
            </g>
        </svg>
    )
};

export default Visibility